// Les moyens de paiement, en logos (SVG inline, couleurs officielles) :
// ce qui rassure au moment du clic, c'est de reconnaître sa carte.
// ⚠️ N'afficher Apple Pay / Google Pay que s'ils sont activés dans Stripe.

const Card = ({ children, label, bg = '#fff' }) => (
  <li className="rg-pl" aria-label={label} title={label} style={{ background: bg }}>{children}</li>
)

export default function PayLogos ({ label }) {
  return (
    <ul className="rg-pls" aria-label={label}>
      <Card label="Apple Pay" bg="#000">
        <svg viewBox="0 0 48 20" aria-hidden="true">
          <path fill="#fff" d="M9.6 4.1c-.5.6-1.3 1-2.1 1-.1-.8.3-1.7.8-2.2.5-.6 1.4-1 2.1-1 .1.8-.3 1.6-.8 2.2zm.8 1.2c-1.2-.1-2.2.7-2.7.7-.6 0-1.4-.6-2.3-.6-1.2 0-2.3.7-2.9 1.8-1.2 2.1-.3 5.3.9 7 .6.9 1.3 1.8 2.2 1.8.9 0 1.2-.6 2.3-.6s1.4.6 2.3.6c1 0 1.6-.9 2.2-1.7.7-1 .9-1.9 1-2-.1 0-1.9-.7-1.9-2.8 0-1.7 1.4-2.6 1.5-2.6-.8-1.2-2.1-1.4-2.6-1.6z" />
          <text x="15" y="14.6" fill="#fff" fontFamily="-apple-system, 'Helvetica Neue', Arial, sans-serif" fontSize="12" fontWeight="500">Pay</text>
        </svg>
      </Card>
      <Card label="Google Pay">
        <svg viewBox="0 0 48 20" aria-hidden="true">
          <path fill="#4285F4" d="M16.3 10.2c0-.5 0-.9-.1-1.3H10v2.5h3.5c-.2.8-.6 1.5-1.3 1.9v1.6h2.1c1.3-1.1 2-2.8 2-4.7z" />
          <path fill="#34A853" d="M10 16.6c1.8 0 3.3-.6 4.3-1.6l-2.1-1.6c-.6.4-1.3.6-2.2.6-1.7 0-3.1-1.1-3.6-2.7H4.2v1.7c1.1 2.1 3.3 3.6 5.8 3.6z" />
          <path fill="#FBBC04" d="M6.4 11.3c-.1-.4-.2-.8-.2-1.3s.1-.9.2-1.3V7H4.2c-.4.9-.7 1.9-.7 3s.3 2.1.7 3l2.2-1.7z" />
          <path fill="#EA4335" d="M10 6c.9 0 1.8.3 2.4.9l1.8-1.8C13.1 4.1 11.7 3.4 10 3.4c-2.5 0-4.7 1.5-5.8 3.6l2.2 1.7C6.9 7.1 8.3 6 10 6z" />
          <text x="19" y="14.6" fill="#3C4043" fontFamily="'Product Sans', Roboto, Arial, sans-serif" fontSize="12" fontWeight="500">Pay</text>
        </svg>
      </Card>
      <Card label="Visa">
        <svg viewBox="0 0 48 20" aria-hidden="true">
          <text x="24" y="15" textAnchor="middle" fill="#1A1F71" fontFamily="Arial Black, Arial, sans-serif" fontSize="13" fontStyle="italic" fontWeight="900" letterSpacing="-.5">VISA</text>
        </svg>
      </Card>
      <Card label="Mastercard">
        <svg viewBox="0 0 48 20" aria-hidden="true">
          <circle cx="19.5" cy="10" r="7" fill="#EB001B" />
          <circle cx="28.5" cy="10" r="7" fill="#F79E1B" />
          <path fill="#FF5F00" d="M24 4.6a7 7 0 0 1 0 10.8 7 7 0 0 1 0-10.8z" />
        </svg>
      </Card>
      <Card label="American Express" bg="#1F72CD">
        <svg viewBox="0 0 48 20" aria-hidden="true">
          <text x="24" y="14" textAnchor="middle" fill="#fff" fontFamily="Arial Black, Arial, sans-serif" fontSize="9.5" fontWeight="900" letterSpacing=".4">AMEX</text>
        </svg>
      </Card>
    </ul>
  )
}
